import React from 'react'

export const DotsIcon = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg'
    style={props.style} className='icon--dots'
    viewBox='0 0 32 32'
  >
    <circle cx='5.8' cy='16' r='2.6' />
    <circle cx='16' cy='16' r='2.6' />
    <circle cx='26.2' cy='16' r='2.6' />
  </svg>
)
